import React from "react";
import App from "./App";
import { jwtDecode } from "jwt-decode";
import { setUserLoggedIn } from "./store/User";
import { setPageLoading } from "./store/Page";
import Spinner from "./components/Spinner";
import { connect } from "react-redux";
import util from "./util";
import api from "./api";
import config from "./config";
import { withRouter } from "react-router-dom";
import {
  redirectToLaunchpadSetup,
} from "./util/nextLaunchpad";
class Root extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Start blocked so App cannot mount before bootstrap finishes.
      loading: true,
    };
  }

  setFaviconEl = (iconUrl) => {
    const favIcon = document.getElementById("favicon");
    if (favIcon) favIcon.href = iconUrl;
  };

  // done by sagar
  componentWillMount() {
    this.props.setPageLoading({isLoading:true})
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.props.setPageLoading({ isLoading: true });

    //if state does not have user information and cookies is not set
    if (
      !window.location.pathname.includes("/user/auth") &&
      !this.props.user &&
      !util.getAuthTokens().access_token
    ) {
      window.location.href = config.authLogoutUrl;
    } else if (
      !window.location.pathname.includes("/user/auth") &&
      !this.props.user &&
      util.getAuthTokens().refresh_token
    ) {
      // if state does not have user but cookies have tokens then set user state
      this.loadUserInfo()
        .then(async (user) => {
          // null => launchpad redirect in progress (keep spinner) or load failed
          if (!user) {
            return;
          }

          if (user.password_update_status === "0") {
            window.location.href = config.authLogoutUrl;
            return;
          }

          await this.finishUserBootstrap(user);
        })
        .catch((err) => {
          console.log(err);
          this.clearBootstrapLoading();
        });
    } else if (window.location.pathname === "/user/auth") {
      this.authenticateUser();
    } else {
      window.location.href = config.authLogoutUrl;
    }
  }

  clearBootstrapLoading = () => {
    this.setState({ loading: false });
    this.props.setPageLoading({ isLoading: false });
  };

  authenticateUser = () => {
    const { location } = this.props;
    this.setState({ loading: true });
    this.props.setPageLoading({ isLoading: true });

    if (location.search) {
      let params = new URLSearchParams(location.search);
      var route = params.get("route");
      var loginvia = params.get("loginvia");
      util.setCookie("loginVia",loginvia);
      if (params.has("user")) {
        api.user
          .verifyUser(params.get("user"))
          .then((resp) => {
           
            const { access_token, refresh_token } = resp.data;

            if (
              resp.status === 200 &&
              access_token &&
              access_token !== "" &&
              refresh_token &&
              refresh_token !== ""
            ) {
              util.setAuthTokens(
                access_token,
                refresh_token,
                params.get("subid")
              );

              this.loadUserInfo()
                .then(async (user) => {
                  // null => launchpad redirect in progress (keep spinner) or load failed
                  if (!user) {
                    return;
                  }

                  sessionStorage.setItem("loginVia", loginvia);
                  await this.finishUserBootstrap(user, { route });
                })
                .catch((err) => {
                  console.log(err.message);
                  this.clearBootstrapLoading();
                });
            } else {
              this.clearBootstrapLoading();
            }

          })
          .catch((err) => {
            console.log(err);
            this.clearBootstrapLoading();
          });
      } else {
        this.clearBootstrapLoading();
      }
    } else {
      this.clearBootstrapLoading();
    }
  };

  // Mount App only after launchpad redirect is skipped (handoff already handled in loadUserInfo).
  finishUserBootstrap = async (user, { route } = {}) => {
    this.setState({ loading: true });
    this.props.setPageLoading({ isLoading: true });

    this.props.setUserLoggedIn({ user });
    this.clearBootstrapLoading();

    if (route !== undefined && route !== null) {
      this.navigateAfterLogin(user, route);
    }
  };

  navigateAfterLogin = (user, route) => {
    const { history } = this.props;
    const isPlgAccount =
      user.is_plg_account === true || user.is_plg_account === 1;
    const plgDefaultLandingRoutes = new Set([
      "dashboard",
      "chat-dashboard",
      "reporting",
    ]);

    if (isPlgAccount && (!route || plgDefaultLandingRoutes.has(route))) {
      history.push("/dashboard-overview");
    } else {
      history.push("/" + route);
    }
  };

  validateuser = () => {
    const sccestoken = util.getAuthTokens().access_token;
    const userinfo = jwtDecode(sccestoken);
    const userId = localStorage.getItem("currentUserId");
    if(!userId){
      localStorage.setItem("currentUserId", userinfo.uId);
    }
    const bc = new BroadcastChannel("admin_lock");
    bc.postMessage(userinfo.uId);
    console.log("Comparing sent user id",userinfo.uId);
    bc.onmessage = (event) => {
      const userId1 = localStorage.getItem("currentUserId");
      if(userId1 && event.data){
        console.log("Comparing user IDs - Received:", event.data, "LocalStorage user_id:", userId);
        if(userId1 != event.data){
          localStorage.removeItem("currentUserId");
          window.location.href = config.baseUrl;
        }
      }
    };
  }
  loadUserInfo = () => {
    this.validateuser();
    // this.setState({loading:true})
    const sccestoken = util.getAuthTokens().access_token;
    var subid = util.getAuthTokens().user_subaccount_id
    return api.user
      .getUserInfo({ subid: subid })
      .then(async (userResp) => {
        // console.log("User Full information : ",userResp );
        
        if (!userResp.data.user.logoUrl) {
          userResp.data.user.logoUrl =
            config.imageUrl + "/assets/media/logos/z.svg";
        }
        if (userResp.data.user.favIcon) {
          this.setFaviconEl(userResp.data.user.favIcon);
        }
        userResp.data.user.user_subaccount_id = util.getAuthTokens().user_subaccount_id;

        userResp.data.user.leftBarAccessList = userResp.data.leftBarAccessList;
        userResp.data.user.totalAvailableModules = userResp.data.totalAvailableModules;
        userResp.data.user.customizedDashboard = userResp.data.customizedDashboard;
        userResp.data.user.userBillingDetail = userResp.data.userBillingDetail;

        const user = userResp.data.user;

        // Right after get_user_info: call handoff next, before App / other APIs.
        try {
          const redirected = await redirectToLaunchpadSetup({ user });
          if (redirected) {
            this.setState({ loading: true });
            this.props.setPageLoading({ isLoading: true });
            return null;
          }
        } catch (err) {
          console.error("Launchpad setup redirect failed:", err);
        }

        return user;
      })
      .catch((err) => {
        this.clearBootstrapLoading();
        console.log(err);
      });
  };
  render() {
    return (
      <React.Fragment>
        {this.state.loading || this.props.isPageLoading ? <Spinner /> : ""}

        {/* Don't mount App until launchpad bootstrap redirect is decided. */}
        {!this.state.loading && this.props.user && <App />}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.company ? true : false,
    isPageLoading: state.page.isLoading ? true : false,
  };
};
export default connect(mapStateToProps, { setUserLoggedIn, setPageLoading })(
  withRouter(Root)
);
